let pageTitle = document.title.trim();
let playbackTitle: string | null = null;

export function setPageDocumentTitle(title: string) {
  pageTitle = title.trim();
  updateDocumentTitle();
}

export function setPlaybackDocumentTitle(
  trackName: string | null,
  siteName: string,
) {
  playbackTitle = trackName
    ? formatPageDocumentTitle(trackName, siteName)
    : null;
  updateDocumentTitle();
}

export function refreshDocumentTitle() {
  updateDocumentTitle();
}

function updateDocumentTitle() {
  const title = playbackTitle || pageTitle;
  if (!title) return;
  if (document.title !== title) {
    document.title = title;
  }
}

export function formatPageDocumentTitle(pageName: string, siteName: string) {
  const normalizedPageName = pageName.trim();
  const normalizedSiteName = siteName.trim();
  if (!normalizedPageName) return normalizedSiteName;
  if (!normalizedSiteName) return normalizedPageName;
  return `${normalizedPageName} - ${normalizedSiteName}`;
}
